import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AngieFormSectionConfig, FormSectionType } from './angie-form-section.model';
import { CommonModule } from '@angular/common';
import { AngieActionBarModule } from './angie-action-bar/angie-action-bar.module';

@Component({
	selector: 'angie-form-section',
	templateUrl: './angie-form-section.component.html',
	styleUrls: ['./angie-form-section.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, AngieActionBarModule]
})
export class AngieFormSectionComponent {
	@Input() config: AngieFormSectionConfig;
	FormSectionType = FormSectionType;
}
